import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'dhl-text-input',
    templateUrl: './simple-text-input.component.html',
    styleUrls: ['./simple-text-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DHLSimpleInput implements OnInit {
  @Input() label: string;
  @Input() text: string;
  @Output() textChanged = new EventEmitter<string>();
  @Input() maxChars: number = 500;
  
  ngOnInit(): void {
  }

  onChange(v: string) {
    this.textChanged.emit(v);
  }
}